export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function statusPill(status) {
  const s = String(status || "").toLowerCase();
  if (s === "pending") return "bg-orange-500/20 text-orange-100 ring-orange-400/25";
  if (s === "active") return "bg-green-500/20 text-green-100 ring-green-400/25";
  if (s === "decline" || s === "declined") return "bg-yellow-500/20 text-yellow-100 ring-yellow-400/25";
  if (s === "withdrawn") return "bg-red-500/20 text-red-100 ring-red-400/25";
  if (s === "scheduled") return "bg-blue-500/20 text-blue-100 ring-blue-400/25";
  if (s === "completed") return "bg-purple-500/20 text-purple-100 ring-purple-400/25";
  if (s === "ghosted") return "bg-yellow-500/20 text-yellow-100 ring-yellow-400/25";
  if (s === "canceled" || s === "cancelled") return "bg-red-500/20 text-red-100 ring-red-400/25";
  if (s === "sold") return "bg-green-500/20 text-green-100 ring-green-400/25";
  return "bg-white/10 text-slate-100 ring-white/10";
}

export function prospectDetailsDefaults(lead) {
  const fullName =
    [lead?.first_name, lead?.last_name].filter(Boolean).join(" ") || lead?.full_name || lead?.name || "";

  return {
    name: fullName || "—",
    phone: lead?.phone || lead?.phone_number || "—",
    email: lead?.email || "—",
    address: lead?.address || "—",
    city: lead?.city || "—",
    state: lead?.state || "—",
    zip: lead?.zip || "—",
    dob: lead?.dob || lead?.date_of_birth || lead?.birthdate || "—",
  };
}

export const formatDobValue = (value) => {
  if (!value) return "—";
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? "—" : value.toLocaleDateString();
  }
  if (typeof value !== "string") return "—";

  // If backend sends ISO date-only (YYYY-MM-DD), render it without timezone shift.
  const m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) {
    return `${m[2]}/${m[3]}/${m[1]}`;
  }

  const parsed = new Date(value);
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toLocaleDateString();
  }
  return "—";
};

export const normalizeDateInput = (value) => {
  if (!value) return "";
  if (typeof value === "string" && value.includes("/")) {
    const [month, day, year] = value.split("/");
    if (!month || !day || !year) return "";
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toISOString().slice(0, 10);
};

export const normalizeInsuranceType = (value) => {
  if (!value) return "";
  const lower = String(value).toLowerCase();
  if (lower.includes("term")) return "Term Life";
  if (lower.includes("universal")) return "Universal Life";
  if (lower.includes("whole")) return "Whole Life";
  if (lower.includes("annuity")) return "Annuity";
  return value;
};

export const pickQuoteRowValue = (rows, matchers, optionIndex = null) => {
  const list = Array.isArray(rows) ? rows : [];
  const mList = Array.isArray(matchers) ? matchers : [];

  const row = list.find((r) => {
    const label = String(r?.label || r?.quote_field_id || "").toLowerCase();
    return mList.some((m) => m.test(label));
  });

  if (!row) return "";

  const opt = row?.options || {};
  
  // If a specific option index is requested, return that option's value
  if (optionIndex !== null && optionIndex !== undefined) {
    return opt?.[optionIndex] || "";
  }
  
  // Default behavior: return first non-empty value
  return opt?.[1] || opt?.[2] || opt?.[3] || "";
};
